import { withInstall } from '@jdesign-vue/utils'
import Dialog from './src/dialog.vue'

export const JdDialog = withInstall(Dialog)
export default JdDialog

export * from './src/use-dialog'
export * from './src/dialog'
export * from './src/constants'
